import { SeoHead } from "@/components/SeoHead"
import { Header } from "@/components/layout/Header"
import { Footer } from "@/components/layout/Footer"
import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export default function CoachUnavailable({ seo, settings = {} }) {
  const { scheduleCallUrl = "#" } = settings

  return (
    <>
      <SeoHead seo={seo} />
      <div className="bg-white text-zinc-900 min-h-screen">
        <Header scheduleCallUrl={scheduleCallUrl} />

        <section className="pt-32 pb-24">
          <div className="mx-auto max-w-2xl px-6 text-center">
            <h1 className="font-display text-4xl md:text-5xl mb-4">
              Assessment unavailable
            </h1>
            <p className="text-lg text-zinc-700 mb-10">
              This assessment link is no longer active. If you're looking to
              connect with a Kingdom Factor coach, we can help you find one.
            </p>
            <Link href="/coach">
              <Button variant="gradient" size="lg">
                Find a coach
              </Button>
            </Link>
          </div>
        </section>

        <Footer />
      </div>
    </>
  )
}
